/** Figma SM checkbox (20px); Modus classic theme maps that physical size to lg, not sm/md. */
export const EDIT_PALETTE_SET_DEFAULT_CHECKBOX_SIZE_PX = 20;

export const EDIT_PALETTE_SET_DEFAULT_CHECKBOX_CSS = `
  modus-wc-checkbox.edit-palette-set-default-checkbox.modus-wc-checkbox-host {
    align-items: center;
    display: flex;
  }

  modus-wc-checkbox.edit-palette-set-default-checkbox .modus-wc-checkbox {
    flex-shrink: 0;
    height: ${String(EDIT_PALETTE_SET_DEFAULT_CHECKBOX_SIZE_PX)}px;
    margin: 0;
    width: ${String(EDIT_PALETTE_SET_DEFAULT_CHECKBOX_SIZE_PX)}px;
  }
`;
